class @App.Clubs.ClubsForm
  container: $('#clubs-application-form-container')

  constructor: ->
    loadSisyphus()
    customizeDobValidationMessages()
    setAdministrativeAreas()
    filterImplementation()
    setOptionalText()
    @bindElements()
    @bindSelectize()
    @restrictInputCharacters()
    @bindDraftValidation()

  loadSisyphus = ->
    $('form').sisyphus()

  # Change the required fields based on saving a draft or submittiing an application
  bindDraftValidation: () ->
    window.Parsley.on 'form:validate', @validateForm
    window.Parsley.on 'form:error', @focusFirstError
    $(document).on 'click', '[type="submit"]', @toggleDraft

  # When saving drafts, only a few fields are required due to integrity checks.
  # We set all other fields to optional.
  # Bound to the parsely 'form:validate' event which returns a Parsley Form object.
  validateForm: (parsleyForm) ->
    $form = parsleyForm.$element

    # If submitting a draft, disable all fields not marked "data-draft-required"
    # Else, ensure all fields are reset
    if $form.data('draft') == 'yes'
      parsleyForm.fields.forEach (field) ->
        excluded = field.$element.data('draft') != 'required'
        inputs = [field.$element]
        inputs = [field.$element, field.$elements...] if field.$elements
        inputs.forEach ($input) => $input.attr('data-parsley-excluded', excluded)
    else
      $form.find('[data-parsley-excluded]').each (idx, field) ->
        $(field).removeAttr('data-parsley-excluded')

    # Refresh parsely to update the new validation rules.
    parsleyForm.refresh()

  # Set the form to either draft for commit mode.
  toggleDraft: (e) ->
    $('form[data-form-name="student_talks"]')
      .data('draft', if $(e.currentTarget).attr('name') == 'draft' then 'yes' else 'no')
    return true

  focusFirstError: (parsleyForm) ->
    firstError = parsleyForm.fields.find((field) -> true != field.validationResult && field.validationResult.length > 0)
    $el = $(firstError.$element.get(0))
    if $el.hasClass("chosen")
      $el.trigger('chosen:activate')
    else if $el.hasClass("selectized") and $el[0].selectize
      $el[0].selectize.focus()
    else
      $el.focus()

  customizeDobValidationMessages = ->
    dob_fields = year: '1i', month: '2i', day: '3i'

    for field, descriptor of dob_fields
      $("#clubs_application_applicant_attributes_date_of_birth_#{descriptor}")
        .attr 'data-parsley-error-message',
              "A valid birthday #{field} is required."
        .attr 'aria-label', field

  loadOrganization = (organization_id) ->
    params = {
      application_id: $('#organization-form').data('application-id'),
      organization_id: organization_id,
      type: "form"
    }

    if organization_id
      $.ajax {
        type: 'get'
        dataType: 'script'
        url: "/student_talks/applications/update_organization?#{$.param( params )}"
      }

  setAdministrativeAreas = ->
    if ($('.clubsApplicationsNewView') ||
        $('.clubsApplicationsEditView').length) &&
       $('#clubs_application_organization_attributes_country_code').length
      # Browser may have cached a country, so reset administrative area
      # based on this cached value
      country_code =
        $('#clubs_application_organization_attributes_country_code').val()
      url = '/student_talks/applications/update_administrative_areas?country_code=' +
            country_code
      application_id = $('#organization-form').data('application-id')
      url += '&id=' + application_id if application_id
      $.ajax {
        type: 'get'
        dataType: 'script'
        url: url
      }

  filterImplementation = ->
    role_value = $('#club-role-k12 input.radio_buttons:checked').data('answer-slug')
    if role_value
      switch role_value
        when 'club-role-school'
          $('[data-answer-slug="club-how-one-group-classroom"]').parent().parent().show()
          $('[data-answer-slug="club-how-one-group-extracurricular"]').parent().parent().show()
          $('[data-answer-slug="club-how-one-group-different"]').parent().parent().show()
          $('[data-answer-slug="club-how-multi-group-same"]').parent().parent().show()
          $('[data-answer-slug="club-how-multi-group-different"]').parent().parent().show()
          $('[data-answer-slug="club-how-one-group-extracurricular-org"]').parent().parent().hide()
          $('[data-answer-slug="club-how-multi-group-same-org"]').parent().parent().hide()
          $('[data-answer-slug="club-how-multi-group-chapters"]').parent().parent().hide()
        when 'club-role-ngo'
          $('[data-answer-slug="club-how-one-group-classroom"]').parent().parent().hide()
          $('[data-answer-slug="club-how-one-group-extracurricular"]').parent().parent().hide()
          $('[data-answer-slug="club-how-one-group-different"]').parent().parent().hide()
          $('[data-answer-slug="club-how-multi-group-same"]').parent().parent().hide()
          $('[data-answer-slug="club-how-multi-group-different"]').parent().parent().hide()
          $('[data-answer-slug="club-how-one-group-extracurricular-org"]').parent().parent().show()
          $('[data-answer-slug="club-how-multi-group-same-org"]').parent().parent().show()
          $('[data-answer-slug="club-how-multi-group-chapters"]').parent().parent().show()


  setOptionalText = ->
    $('.answer-optional-text').each (i, el) ->
      $el = $(el)
      answer_ids = $el.data('optional-text-answer-ids')

      triggers = []
      for answer_id in answer_ids
        triggers.push($('[type=radio][value=' + answer_id + ']'))
        triggers.push($('input[value=' + answer_id + ']'))

      show = false
      for trigger in triggers
        show = true if trigger.prop('checked')
      if show
        $el.show()
      else
        $el.hide()

      $('.clubs-application-form').on 'change', (e) ->
        show = false
        for trigger in triggers
          show = true if trigger.prop('checked')
        if show
          $el.show()
        else
          $el.hide()

  bindElements: ->
    $(document).on 'change', '#clubs_application_organization_attributes_country_code', (e) ->
      input = $(this)
      setAdministrativeAreas(input.val())

    $(document).on 'change', '#club-role-k12', (e) ->
      filterImplementation()

  bindSelectize: ->
    clearFieldError = () ->
      $('#clubs_application_organization_id')
        .parsley()
        .reset()

    setFieldError = (message) ->
      clearFieldError()
      $('#clubs_application_organization_id')
        .parsley()
        .addError("server", { message })

    $('#clubs_application_organization_id').selectize(
      plugins: ['selectize-plugin-a11y']
      valueField: 'id'
      labelField: 'name'
      searchField: 'name'
      create: (input, callback) ->
        if /TED-?\s?Ed/.test(input)
          setFieldError('Organization name cannot include "TED-Ed"')
          return false

        $.ajax {
          url: '/api/v2/clubs/organizations/?clubs_organization[name]=' +
               encodeURIComponent(input)
          type: 'POST'
          error: (jqXHR) ->
            errorMessage = "Organization name " + jqXHR.responseJSON.errors.name.join(", ")
            setFieldError(errorMessage)
            callback()
          success: (res) =>
            callback res.organization
            clearFieldError()
            loadOrganization(res.organization.id, "form")
        }
        return undefined
      render:
        option: (item, escape) ->
          location = ''
          location = escape(item.country_name) if item.country_name
          location = escape(item.administrative_area) + ', ' +
                     location if item.administrative_area
          location = escape(item.city) + ', ' + location if item.city
          id = "#{item.name}-#{location}".toLowerCase().replace(/[^a-zA-Z0-9]+/g, "-")

          return """
            <div class="option" role="option" id="#{id}">
              <span class="title">
                <span class="name">#{escape(item.name)}</span>
              </span>
              <span class="description">#{location}</span>
            </div>
          """
      onItemAdd: (value, $item) ->
        loadOrganization(value)
      load: (query, callback) ->
        return callback if !query.length
        $.ajax {
          url: '/api/v2/clubs/organizations/?filter[name]=' +
               encodeURIComponent(query)
          type: 'GET'
          error: ->
            callback()
          success: (res) ->
            callback res.organizations.slice(0, 10)
        }
    )
    .on 'change', (e) ->
      $(e.currentTarget).parsley().validate({ force: true })

  restrictInputCharacters: ->
    $('form[data-form-name="student_talks"]')
      .find('input[type="text"], textarea')
      .on('input', (e) -> (
        e.target.value = e.target.value.replace(/[^\p{sc=Latin}\u0021-\u005C\s]/gu, '')
      ))
$ ->
  new App.Clubs.ClubsForm() if $('.clubs-application-form').length
